import { useMutation, useQueryClient } from '@tanstack/react-query';

import BackendService from '../services/backendService';
import { ReportInsightType } from './useReportInsights';
import useRouterMatch from './useRouterMatch';

const useGenerateReportInsight = () => {
  const queryClient = useQueryClient();
  const { gameId: livePresentationId } = useRouterMatch();
  const { mutate: generateInsight, isPending: isLoading, error } = useMutation({
    mutationFn: async ({
      reportType,
      participantId,
    }: {
      reportType: ReportInsightType | 'all';
      participantId?: string;
    }) => {
      return BackendService.instance.ai.generateReportInsights({
        livePresentationId,
        reportType,
        participantId,
      });
    },

    onSuccess: (data, { reportType, participantId }) => {
      if (Array.isArray(data)) {
        data.map(insight => {
          queryClient.setQueryData(
            [
              'report-insight',
              insight.type,
              livePresentationId,
              insight.participantId || '',
            ],
            insight,
          );
        });
        return;
      }
      queryClient.setQueryData(
        ['report-insight', reportType, livePresentationId, participantId || ''],
        data,
      );
    },

    retry: 0
  });
  const {
    mutate: generateInsightForAllStudents,
    isPending: isLoadingAllStudent,
  } = useMutation({
    mutationFn: async () => {
      return BackendService.instance.ai.generateReportInsightsForAllStudents({
        livePresentationId,
      });
    },

    onSuccess: data => {
      data.map(insight => {
        queryClient.setQueryData(
          [
            'report-insight',
            'studentSummary',
            livePresentationId,
            insight.participantId,
          ],
          insight,
        );
      });
    }
  });

  return {
    generateInsight,
    generateInsightForAllStudents,
    isLoading,
    isLoadingAllStudent,
    error,
  };
};

export default useGenerateReportInsight;
